import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C05MulticolumnCTAProps = RenderingProps<
  C05MulticolumnCTAFields,
  C05MulticolumnCTAParams
>;

export type C05MulticolumnCTAFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
};

export type C05MulticolumnCTAParams = {
  HeadlineTag?: string;
  ContentAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
